import { getLastTab, resolveTargetTabId } from '@/router/utils/lastTabStorage'
import {
  ADDRESS_BOOK_LAST_TAB_KEY,
  ADDRESS_BOOK_TABS
} from '@/router/contacts/addressBookTabs'

const WorkInProgressComponent = () =>
  import('@/views/wip/WorkInProgressComponent')
const TheAddressBookPage = () =>
  import('@/views/contact/addressBook/TheAddressBookPage.vue')
const TheAddressBookTabPage = () =>
  import('@/views/contact/addressBook/TheAddressBookTabPage.vue')
const TheContactViewPage = () =>
  import('@/views/contact/TheContactViewPage.vue')

export const contactsRootPages = {
  path: 'contacts',
  name: 'contacts_route',
  component: WorkInProgressComponent
}

export const contactsSubPages = [
  {
    path: 'contacts/address-book',
    name: 'address_book_page_route',
    component: TheAddressBookPage,
    /**
     * A function, not a static target: it is evaluated on every visit, so it
     * reads the tab the user actually left off on rather than the one that was
     * stored when this module was first imported. `resolveTargetTabId` falls
     * back to the first tab when nothing is remembered, and also when what is
     * remembered is no longer one of the four — a route name that survived a
     * rename would otherwise redirect to nowhere.
     */
    redirect: () => ({
      name: resolveTargetTabId(
        ADDRESS_BOOK_TABS,
        getLastTab(ADDRESS_BOOK_LAST_TAB_KEY)
      )
    }),
    /**
     * Derived from the tab list rather than spelled out, so a tab cannot gain a
     * route without a label or a label without a route. The path is the tab's
     * own API value, which is what the URL should read anyway.
     */
    children: ADDRESS_BOOK_TABS.map(({ id, tab }) => ({
      path: tab,
      name: id,
      component: TheAddressBookTabPage,
      props: { tab }
    }))
  },
  {
    path: 'contact/:contactId',
    name: 'contact_view_route',
    component: TheContactViewPage,
    props: (route) => {
      return {
        type: 'contact',
        ...route.params
      }
    }
  }
]
